import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing()
  },
  checkbox: {
    marginTop: -3,
    marginLeft: -45,
    '& svg': {
      width: 20,
      height: 20,
      color: theme.palette.primary.main
    }
  },
  checkboxDisabled: {
    '& svg': {
      color: 'gray'
    }
  },
  button: {
    marginTop: -5,
    '& svg': {
      width: 20,
      height: 20
    }
  },
  disabled: {
    '& svg': {
      color: 'gray'
    }
  },
  offLineText: {
    fontWeight: 500,
    fontSize: '.875rem',
    marginBottom: 5
  },
  ellipsisText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  ellipsisMultilineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },
  offLineTextTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    width: 200,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    '&.disabled': {
      borderBottom: `1px solid gray`,
      color: 'gray',
      fontWeight: 600,
      marginBottom: theme.spacing(1.5),
      width: 200
    }
  },
  offLineTextDisabled: {
    color: '#9E9FA5'
  },
  cardForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(),
    marginTop: theme.spacing()
  },
  submitButton: {
    alignSelf: 'center',
    height: 41,
    marginTop: theme.spacing(2),
    width: 215
  },
  saveButton: {
    marginTop: theme.spacing(3)
  },
  errorMessage: {
    marginLeft: 14
  },
  formGroup: {
    minHeight: 60
  }
}))
